import React, { useState, FormEvent } from 'react'

import { mergeSuppliers, getSupplier, toastSuccess } from '../../../api'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from './defineAbility'
import { TooltipWrapper } from 'components/common'
import { toast } from 'react-toastify'

interface CardProps {
    supplierId: number
    onMergeSuccess?: () => void
}

export const SupplierMergeCard = ({ supplierId, onMergeSuccess }: CardProps) => {

    const ability = defineAbilityFor(getAuthUser())
    const [supplierIdInput, setSupplierId] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const isSelfMerge = Number(supplierIdInput) === supplierId

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (Number(supplierIdInput) === supplierId) {
            toast.error('You cannot merge a supplier into itself.', { autoClose: false })
            return
        }

        setIsLoading(true)

        try {
            const supplierCheck = await getSupplier(supplierIdInput)

            if (!supplierCheck?.data) {
                toast.error('The supplier ID entered does not exist.', { autoClose: false })
                setIsLoading(false)
                return
            }

            const confirmed = window.confirm(
                `Are you sure you want to merge supplier ID ${supplierIdInput} into supplier ID ${supplierId}? This will delete supplier ID ${supplierIdInput}. This action cannot be undone.`
            )

            if (!confirmed) {
                setIsLoading(false)
                return
            }

            const response = await mergeSuppliers(supplierId, supplierIdInput)

            if (response.status === 200) {
                toastSuccess('Suppliers merged successfully.')
                setSupplierId('')
                if (onMergeSuccess) onMergeSuccess()
            }
        } catch (error: any) {
            console.error('Error merging supplier:', error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="container card mb-5">
            <div className="card-body row d-flex flex-row justify-content-between">
                <div className="row flex-row mb-4 pe-0">
                    <h3 className="ps-0 d-inline-flex card-title w-50">Merge</h3>
                </div>

                <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="mb-3">
                        <label htmlFor="supplierId" className="form-label">
                            Input Supplier ID
                        </label>
                        <input
                            type="text"
                            id="supplierId"
                            name="supplierId"
                            className="form-control"
                            value={supplierIdInput}
                            onChange={(e) => setSupplierId(e.target.value)}
                            placeholder="Enter Supplier ID"
                            required
                        />
                    </div>

                    <TooltipWrapper
                        condition={ability.can('Create', 'SupplierMerge')}
                        message={!ability.can('Create', 'SupplierMerge') ? 'Insufficient permissions' : isSelfMerge ? 'Cannot merge a supplier into itself' : ''}
                        element={
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={!ability.can('Create', 'SupplierMerge') || isLoading || isSelfMerge}
                            >
                                {isLoading ? 'Merging...' : 'Submit'}
                            </button>
                        }
                    />
                </form>
            </div>
        </div>
    )
}
